const forEachPolyfill = () => {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
};

export default forEachPolyfill;



// WEBPACK FOOTER //
// ./assets/js/modules/foreach-polyfill.js